import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import { useSizingPageModalContext } from '../contexts/SizingPageModalProvider';
import SizingPageSection from './SizingPageSection';

const HeadingAfter = (): JSX.Element => {
  const t = useTranslations();
  const modalContext = useSizingPageModalContext();

  const toggleModal = () => {
    modalContext.setRingModelsVisible(true);
  };

  return (
    <button
      className="mt-5 inline-block text-lg font-bold text-sandstone-500 underline"
      data-cy="sizing-guides-section-title-after"
      onClick={toggleModal}
      type="button"
    >
      {t('sizing_gen4_sizing_guides_title_after')}
    </button>
  );
};

const SizingGuidesSection = (): JSX.Element => {
  const t = useTranslations();
  const modalContext = useSizingPageModalContext();

  const onGen4SizingGuideClick = () => {
    modalContext.setOr4SizeGuideVisible(true);
  };

  const onGen3SizingGuideClick = () => {
    modalContext.setOr3SizeGuideVisible(true);
  };

  return (
    <SizingPageSection
      data-cy="sizing-guides-section"
      heading={{
        after: <HeadingAfter />,
        content: 'sizing_gen4_sizing_guides_title',
      }}
    >
      <TypographyV3 Element="h3" variant="h4">
        {t('sizing_gen4_sizing_guides_or4_title')}
      </TypographyV3>
      <TypographyV3 className="text-lg">
        {t.rich('sizing_gen4_sizing_guides_or4_content')}
      </TypographyV3>
      <ButtonV3
        data-cy="sizing-guides-section-gen4-cta"
        onClick={onGen4SizingGuideClick}
        variant="secondary-dark"
      >
        {t.rich('sizing_gen4_sizing_guides_or4_cta')}
      </ButtonV3>
      <TypographyV3 Element="h3" variant="h4">
        {t('sizing_gen4_sizing_guides_or3_title')}
      </TypographyV3>
      <TypographyV3 className="text-lg">
        {t.rich('sizing_gen4_sizing_guides_or3_content')}
      </TypographyV3>
      <ButtonV3
        data-cy="sizing-guides-section-gen3-cta"
        onClick={onGen3SizingGuideClick}
        variant="secondary-dark"
      >
        {t.rich('sizing_gen4_sizing_guides_or3_cta')}
      </ButtonV3>
    </SizingPageSection>
  );
};

export default SizingGuidesSection;
